import amertrad1 from './amertrad1.png'
import amertrad2 from './amertrad2.png'
import amertrad3 from './amertrad3.png'
import amertrad4 from './amertrad4.png'
import amertrad5 from './amertrad5.png'
import amertrad6 from './amertrad6.png'
import amertrad7 from './amertrad7.png'
import amertrad8 from './amertrad8.png'
import amertrad9 from './amertrad9.png'
import amertrad10 from './amertrad10.png'
import amertrad11 from './amertrad11.png'

 const americanTraditional = [
    amertrad1,
    amertrad2,
    amertrad3,
    amertrad4,
    amertrad5,
    amertrad6,
    amertrad7,
    amertrad8,
    amertrad9,
    amertrad10,
    amertrad11
]

export default americanTraditional
